import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Clock, Loader2 } from "lucide-react";
import { useLang } from "@/lib/LanguageContext";
import { historyAPI } from "@/lib/api";
import RecipeCard from "@/components/RecipeCard";

export default function History() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    historyAPI
      .list()
      .then((r) => setHistory(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="history-page">
      <div className="flex items-center gap-3 mb-8">
        <Clock className="w-6 h-6 text-amber-500" />
        <h1 className="font-heading text-2xl sm:text-3xl tracking-tight font-medium text-white">
          {t("historyTitle")}
        </h1>
      </div>

      {loading ? (
        <div className="flex justify-center py-20">
          <Loader2 className="w-8 h-8 animate-spin text-amber-500" />
        </div>
      ) : history.length === 0 ? (
        <div className="text-center py-20">
          <Clock className="w-12 h-12 text-stone-700 mx-auto mb-4" />
          <p className="text-stone-500">{t("noHistory")}</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {history.map((item) => (
            <div key={item.id}>
              <RecipeCard
                recipe={item.recipe}
                onClick={() => navigate("/recipe", { state: { recipe: item.recipe } })}
              />
              {item.ingredients?.length > 0 && (
                <div className="mt-2 flex flex-wrap gap-1">
                  {item.ingredients.map((ing, i) => (
                    <span key={i} className="text-[10px] text-stone-600 bg-stone-900 px-2 py-0.5 rounded-full capitalize">
                      {ing}
                    </span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
